'use client'

import React, { useEffect, useState } from 'react'

import { usePrefersReducedMotion } from '@/components/findex-connect/hooks/usePrefersReducedMotion'
import { useViewport } from '@/components/findex-connect/hooks/useViewport'

export const BlurryLightsDaytime = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const { viewportWidth } = useViewport()
  const prefersReducedMotion = usePrefersReducedMotion()

  // Below the connect lg breakpoint (64rem, tailwind.connect.config.js) and
  // for reduced-motion users the lights render as static radial gradients
  // with no filter, blend mode or animation. iOS Safari re-composites large
  // blur(120px) + mix-blend-mode layers on every scrolled frame even when
  // static, which is what makes the page feel slow on real iPhones; Chrome
  // rasterises them once, so emulation does not show it.
  const animate = viewportWidth >= 1024 && !prefersReducedMotion

  useEffect(() => {
    setIsLoaded(true)
  }, [])
  return (
    <div className="gradient-bg light bg-gradient-to-[40deg] absolute top-0 left-0 -z-10 h-full w-full overflow-hidden bg-[var(--color-bg1)]">
      <div
        className={`${!isLoaded ? 'invisible' : ''} gradients-container h-full w-full ${animate ? 'backdrop-blur-[40px]' : ''}`}
      >
        <div
          className={`pointer-events-none absolute top-[-20%] left-0 h-[calc(var(--circle-size)_*_1)] w-[calc(var(--circle-size)_*_1.5)] origin-center opacity-40 ${animate ? 'mix-blend-[var(--blending)] animate-[moveVertical_40s_infinite_var(--ease)] rounded-full bg-[var(--color1)] blur-[120px]' : 'bg-[radial-gradient(closest-side,var(--color1),transparent)]'}`}
        ></div>
        <div
          className={`pointer-events-none absolute top-[calc(50%_-_var(--circle-size)_/_2)] left-0 h-[var(--circle-size)] w-[var(--circle-size)] origin-[calc(50%_-_400px)] opacity-40 ${animate ? 'mix-blend-[var(--blending)] animate-[moveHorizontal_30s_reverse_infinite_var(--ease)] rounded-full bg-[var(--color2)] blur-[120px]' : 'bg-[radial-gradient(closest-side,var(--color2),transparent)]'}`}
        ></div>
        <div
          className={`pointer-events-none absolute top-[calc(50%_-_var(--circle-size)_/_2)] left-[calc(75%_-_var(--circle-size)_/_2)] h-[calc(var(--circle-size)_*_1.5)] w-[calc(var(--circle-size)_*_2)] origin-[calc(50%_+_400px)] opacity-40 ${animate ? 'mix-blend-[var(--blending)] animate-[moveHorizontalReverse_60s_infinite_var(--ease)] rounded-full bg-[var(--color3)] blur-[120px]' : 'bg-[radial-gradient(closest-side,var(--color3),transparent)]'}`}
        ></div>
      </div>
    </div>
  )
}
